import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class JobNotesModalButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const { job } = this.props;
        const notes = job?.notes;

        if (!job || !notes) {
            return null;
        }

        const { showModal } = this.state;

        return (
            <>
                <Button
                    id={`job-notes-${job.id}`}
                    color="info"
                    className="p-1 ml-2 mr-2 align-baseline"
                    type="button"
                    title="Published Notes"
                    onClick={this.toggleModal}
                    outline
                >
                    <FontAwesomeIcon icon={faInfoCircle} /> Notes
                </Button>
                <Modal
                    isOpen={showModal}
                    target={`job-notes-${job.id}`}
                    toggle={this.toggleModal}
                    fade={false}
                    size="xl"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Job Notes - {job.name}
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
